module.exports = __webpack_public_path__ + "static/img1-66c46a902b9300bf7ae7b70d74533860.png";